import { Injectable, computed, signal } from '@angular/core';
import { Order } from '../interfaces/payment-summary.interface';

@Injectable({providedIn: 'root'})
export class CartStateService {

  constructor() {
    console.log('>>>>', Math.random());
  }

  orders = signal<Order[]>([]);
  cartId = signal<string | null>(null);

  setOrders(orders: Order[]) {
    this.orders.set(orders);
  }

  setCartId(cartId: string | null) {
    this.cartId.set(cartId);
  }

  emptyCart = signal(false);
  
  setEmptyCartAsTrue() {
    this.emptyCart.set(true);
    this.setCartId(null);
  }

  setEmptyCartAsFalse() {
    this.emptyCart.set(false);
  }

  ordersForSum = computed(() => {
    return this.orders()
      .filter(each => each.specialSection !== 'DONATION');
  });

  donationOrder = computed(() => {
    return this.orders().find(each => each.specialSection === 'DONATION');
  });

  donationOrderTotal = computed(() => {
    return this.donationOrder()?.purchaseItems[0]?.unitAmount || 0;
  });

  subtotal = computed(() => {
    return this.ordersForSum().reduce((previous, current) => {
      return previous + current.purchaseItems.reduce((p, c) => {
        return p + c.unitAmount * c.quantity
      }, 0)
    }, 0)
  });

  total = computed(() => {
    return this.subtotal() - this.coupon() + this.donationOrderTotal() || 0;
  });
  
  coupon = signal(0);

  setCouponAmount(couponAmount: number) {
    this.coupon.set(couponAmount);
  }

  totalItems = computed(() => {
    return this.ordersForSum().reduce((previous, current) => {
      return previous + current.purchaseItems.reduce((p, c) => {
        return p + c.quantity
      }, 0)
    }, 0)
  });
  
  couponAndDonationSectionsEnabled = signal(false);

  setCouponAndDonationSection(enable: boolean) {
    this.couponAndDonationSectionsEnabled.set(enable);
  }

}
